"use client"

import { Box, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableRow, Typography, useMediaQuery, useTheme } from "@mui/material"
import { CheckCircle, CheckSquare, ListTodo, Medal, BookOpen } from "lucide-react"
import { Link, useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { IDashboardMetrics } from "@/api";

export interface IDashboardMetricsExtend extends IDashboardMetrics {}

interface DashboardMetricsProps {
  initialData?: IDashboardMetricsExtend;
}

export default function DashboardMetrics({
  initialData,
}: DashboardMetricsProps) {
  const navigate = useNavigate();
  const [dashboarMetrics, setDashboarMetrics] =
    useState<IDashboardMetricsExtend | null>(null);
  // const { dashboarMetrics } = useDashboardContext();
  useEffect(() => {
    if(initialData){
      setDashboarMetrics(initialData);
    }
  }, [initialData]);

  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))

  const metrics = [
    {
      icon: <CheckCircle size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.count) || 0,
      label: "Courses Enrolled",
      link: "my-courses",
    },
    {
      icon: <CheckCircle size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.totalCourseCompleted) || 0,
      label: "Courses Completed",
      link: "course-statistics",
    },
    {
      icon: <CheckSquare size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.totalActivityCompleted) || 0,
      label: "Activities Completed",
      link: "course-activities",
    },
    {
      icon: <ListTodo size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.totalActivityDue) || 0,
      label: "Activities Due",
      link: "course-activities",
    },
    {
      icon: <Medal size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.totalBadges) || 0,
      label: "Badges",
      link: "my-badges",
    },
    {
      icon: <BookOpen size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />,
      value: Number(dashboarMetrics?.totalContests) || 0,
      label: "Contests",
      link: "my-contests",
    },
  ]
  return (
    <Paper
      sx={{
        borderRadius: 2,
        bgcolor: "white",
        boxShadow: "0 1px 3px rgba(0,0,0,0.12)",
        p: { xs: 2, sm: 4 },
      }}
    >
      <Typography
        variant="h6"
        sx={{
          color: "rgb(0, 102, 204)",
          fontWeight: 500,
          mb: { xs: 2, sm: 3 },
          px: { xs: 1, sm: 0 },
        }}
      >
        From PGuide
      </Typography>

      {/* <TableContainer
        component={Box}
        sx={{
          px: 7,         // Tăng padding ngang
          py: 1,
          "& .MuiTable-root": {
            tableLayout: "fixed",
            width: "100%",
          },
        }}
      >
        <Table
          sx={{
            width: "100%",      // Giãn toàn bộ chiều rộng
            tableLayout: "fixed", // Cố định layout bảng
            margin: "0 auto",   // Căn giữa bảng
          }}
        >
          <TableBody>
            <TableRow>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                <MetricItem
                  icon={<CheckCircle size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                  value={Number(dashboarMetrics?.count) || 0}
                  label="Courses Enrolled"
                  link="my-courses"
                />
              </TableCell>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                <MetricItem
                  icon={<CheckCircle size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                  value={Number(dashboarMetrics?.totalCourseCompleted) || 0}
                  label="Courses Completed"
                  link="course-statistics"
                />
              </TableCell>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                <MetricItem
                  icon={<CheckSquare size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                  value={Number(dashboarMetrics?.totalActivityCompleted) || 0}
                  label="Activities Completed"
                  link="course-activities"
                />
              </TableCell>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                  <MetricItem
                    icon={<ListTodo size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                    value={Number(dashboarMetrics?.totalActivityDue) || 0}
                    label="Activities Due"
                    link="course-activities"
                  />
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                <MetricItem
                  icon={<Medal size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                  value={Number(dashboarMetrics?.totalBadges) || 0}
                  label="Badges"
                  link="my-badges"
                />
              </TableCell>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }}>
                <MetricItem
                  icon={<BookOpen size={24} style={{ color: "#57cf0a", width: 38, height: 38 }} />}
                  value={Number(dashboarMetrics?.totalContests) || 0}
                  label="Contests"
                  link="my-contests"
                />
              </TableCell>
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }} />
              <TableCell sx={{ width: "25%", borderBottom: "none", pl: 3, pr: 3, py: 2 }} />
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer> */}
      <Grid container spacing={{ xs: 2, sm: 3 }} sx={{ px: { xs: 1, sm: 3 } }}>
        {metrics.map((metric, index) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            key={index}
            sx={{
              display: "flex",
              justifyContent: { xs: "center", sm: "flex-start" },
            }}
          >
            <MetricItem {...metric} />
          </Grid>
        ))}
      </Grid>
    </Paper>
  )
}

interface MetricItemProps {
  icon: React.ReactNode
  value: number
  label: string
  link?: string
}

function MetricItem({ icon, value, label, link }: MetricItemProps) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
  return (
    <Box sx={{
      display: "flex",
      alignItems: "center",
      gap: 2,
      width: { xs: "100%", sm: "auto" },
    }}>
      <Box>{icon}</Box>
      <Box>
        <Typography
          variant={isMobile ? "h5" : "h4"}
          sx={{
            fontWeight: "bold",
            mb: 0.5,
          }}
        >
          {value}
        </Typography>
        {link ? (
          <Link
            to={`../${link}`}
            style={{ textDecoration: "none" }}
          >
            <Typography
              variant="body2"
              sx={{
                fontWeight: 500,
                color: "#000", // Màu mặc định
                "&:hover": {
                  color: "#07d007", // Màu khi hover
                },
                transition: "color 0.3s ease"
              }}
            >
              {label}
            </Typography>
          </Link>
        ) : (
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              fontWeight: 500,
            }}
          >
            {label}
          </Typography>
        )}
      </Box>
    </Box>
  )
}

